/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { useAppSelector } from '@/hooks';
import { useTranslations } from '@/hooks/useTranslations';
import { useUpdateJobToFailMutation } from '@/store/apis';
import { Button, MenuItem, Modals } from '@ui5/webcomponents-react';
import { useId } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionCardMenuButton({ flowId, runId }: { flowId: string; runId: string }) {
    const id = useId();
    const { t } = useTranslations();
    const [updateJobToFail, { isLoading }] = useUpdateJobToFailMutation();
    const navigate = useNavigate();
    const cleanUpButtonEnabled = useAppSelector(state => state.productList.isCleanUpButtonEnabled);

    return (
        <Button
            id={id}
            icon="overflow"
            design="Transparent"
            onClick={() =>
                Modals.showMenu({
                    opener: id,
                    children: (
                        <>
                            {cleanUpButtonEnabled && (
                                <MenuItem
                                    icon="reset"
                                    text={t('CLEAN_UP_BUTTON_LANDING')}
                                    onClick={() => updateJobToFail({ runId })}
                                    disabled={isLoading}
                                />
                            )}
                            <MenuItem
                                icon="document-text"
                                text={t('VIEW_REPORT_BUTTON_LANDING')}
                                onClick={() => navigate(`/viewReport/flow/${flowId}/run/${runId}`)}
                            />
                        </>
                    ),
                })
            }
        />
    );
}
